<template>
  <div class="cheatsheet" @click="$emit('click-cheatsheet')">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1440"
      height="810"
      viewBox="0 0 1440 810"
      fill="none"
    >
      <g filter="url(#filter0_b_3116_4829)">
        <rect
          width="1440"
          height="810"
          fill="black"
          fill-opacity="0.6"
        />

        <g filter="url(#filter3_b_3116_4829)">

        </g>
        <path
          ref="qr-code-pointer"
          class="qr-code-group"
          :style="qrPointerTranslateX"
          d="M1013.33 52C1013.33 50.5272 1014.53 49.3333 1016 49.3333C1017.47 49.3333 1018.67 50.5272 1018.67 52C1018.67 53.4728 1017.47 54.6667 1016 54.6667C1014.53 54.6667 1013.33 53.4728 1013.33 52ZM1032 114L1032 114.5L1032 114ZM1015.5 98L1015.5 52L1016.5 52L1016.5 98L1015.5 98ZM1049 114.5L1032 114.5L1032 113.5L1049 113.5L1049 114.5ZM1016.5 98C1016.5 106.56 1023.44 113.5 1032 113.5L1032 114.5C1022.89 114.5 1015.5 107.113 1015.5 98L1016.5 98Z"
          fill="white"
        />
        <g
          class="qr-code-group"
          filter="url(#filter5_b_3116_4829)"
          :style="qrPointerTranslateX"
        >
          <path d="M994 91C994 86.5817 997.582 83 1002 83H1206C1210.42 83 1214 86.5817 1214 91V127C1214 131.418 1210.42 135 1206 135H1002C997.582 135 994 131.418 994 127V91Z" fill="#F0F4FA" />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"
            font-size="16"
            letter-spacing="0em"
          ><tspan x="1006.16" y="114.264">Show / Hide QR Code</tspan></text>
          <rect
            x="1174"
            y="95"
            width="28"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="1183.01" y="113.606">Q</tspan></text>
        </g>
        <path
          v-if="showResultGroup"
          class="result-group"
          :style="resultPointerTranslateX"
          ref="result-pointer"
          d="M305.333 744C305.333 742.527 306.527 741.333 308 741.333C309.473 741.333 310.667 742.527 310.667 744C310.667 745.473 309.473 746.667 308 746.667C306.527 746.667 305.333 745.473 305.333 744ZM307.5 744V624H308.5V744H307.5ZM324 607.5H395V608.5H324V607.5ZM307.5 624C307.5 614.887 314.887 607.5 324 607.5V608.5C315.44 608.5 308.5 615.44 308.5 624H307.5Z"
          fill="white"
        />
        <g
          v-if="showResultGroup"
          :style="resultPointerTranslateX"
          class="result-group"
          filter="url(#filter6_b_3116_4829)"
        >
          <rect
            x="345"
            y="581"
            width="254"
            height="52"
            rx="8"
            fill="#F0F4FA"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"
            font-size="16"
            letter-spacing="0em"
          ><tspan x="357" y="612.264">Show / hide results</tspan></text>
          <rect
            x="559"
            y="593"
            width="28"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"
            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="567.586" y="611.606">H</tspan></text>
        </g>
        <path class="back-button-pointer" d="M41.3333 52C41.3333 50.5272 42.5272 49.3333 44 49.3333C45.4728 49.3333 46.6667 50.5272 46.6667 52C46.6667 53.4728 45.4728 54.6667 44 54.6667C42.5272 54.6667 41.3333 53.4728 41.3333 52ZM43.5 92L43.5 52L44.5 52L44.5 92L43.5 92ZM60 107.5L71 107.5L71 108.5L60 108.5L60 107.5ZM44.5 92C44.5 100.56 51.4396 107.5 60 107.5L60 108.5C50.8873 108.5 43.5 101.113 43.5 92L44.5 92Z" fill="white" />
        <g
          v-if="showSubmissionGroup"
          class="submission-group"
          :style="submissionPointerTranslateX"
          filter="url(#filter7_b_3116_4829)"
        >
          <rect
            x="344"
            y="659"
            width="252"
            height="52"
            rx="8"
            fill="#F0F4FA"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"
            font-size="16"
            letter-spacing="0em"
          ><tspan x="356" y="690.264">Open / close submission</tspan></text>
          <rect
            x="556"
            y="671"
            width="28"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="565.584" y="689.606">S</tspan></text>
        </g>
        <g filter="url(#filter8_b_3116_4829)">
          <path d="M23 91C23 86.5817 26.5817 83 31 83H231C235.418 83 239 86.5817 239 91V127C239 131.418 235.418 135 231 135H31C26.5817 135 23 131.418 23 127V91Z" fill="#F0F4FA" />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="16"
            letter-spacing="0em"
          ><tspan x="35" y="114.264">Back to Editor</tspan></text>
          <rect
            x="184"
            y="95"
            width="43"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="192.218" y="113.606">ESC</tspan></text>
        </g>
        <g
          class="effect-group"
          :style="effectPointerTranslateX"
          filter="url(#filter9_b_3116_4829)"
        >
          <path d="M23 589C23 584.582 26.5817 581 31 581H231C235.418 581 239 584.582 239 589V697C239 701.418 235.418 705 231 705H31C26.5817 705 23 701.418 23 697V589Z" fill="#F0F4FA" />
          <g clip-path="url(#clip1_3116_4829)">
            <path d="M54.2363 611.31C53.1607 611.766 52.1118 612.249 51.036 612.705C47.4324 614.262 43.8287 615.818 40.1981 617.374C39.2568 617.777 38.2887 618.206 37.3474 618.581C36.8364 618.796 36.3524 618.796 35.9221 618.581C35.7607 618.501 35.5994 618.394 35.438 618.233C34.927 617.723 34.7926 617.025 35.0884 616.328C35.1153 616.274 35.2229 616.006 35.3842 615.63C36.7827 612.383 42.3495 599.451 42.4033 599.37C42.4033 599.397 42.3226 599.907 42.3495 599.934C42.4571 600.631 42.726 601.248 43.0219 601.865C43.1832 602.187 43.3446 602.509 43.5329 602.831C44.2052 603.985 45.012 605.005 45.8994 605.998C45.9801 606.105 46.0608 606.185 46.1684 606.293C46.7062 606.883 47.2979 607.446 47.8895 607.956C48.4812 608.493 49.1267 608.976 49.772 609.432C50.4175 609.861 51.063 610.264 51.7353 610.586C52.5421 610.961 53.3489 611.256 54.2363 611.31Z" fill="#E6575B" />
            <path d="M45.9263 605.997L35.9221 618.581C35.7607 618.5 35.5994 618.393 35.438 618.232C34.927 617.722 34.7926 617.024 35.0884 616.327C35.1153 616.273 35.2229 616.005 35.3842 615.629L43.3446 602.965L43.5329 602.857C44.2052 603.958 45.0389 605.004 45.9263 605.997Z" fill="#EE7077" />
            <path d="M54.9698 610.965C56.2092 609.729 54.4809 606 51.1096 602.636C47.7383 599.273 44.0008 597.549 42.7615 598.785C41.5222 600.021 43.2505 603.75 46.6218 607.114C49.9929 610.477 53.7306 612.202 54.9698 610.965Z" fill="#BD393C" />
            <path d="M39.445 602.214C39.3912 602.214 39.3105 602.214 39.2567 602.187C38.9878 602.08 38.8264 601.785 38.934 601.49C38.934 601.463 39.956 598.645 39.3912 596.606C39.2836 596.177 39.1492 596.096 39.1492 596.096C38.9878 596.096 38.4768 596.553 38.1272 597.116C37.9659 597.357 37.6431 597.438 37.3742 597.277C37.1322 597.116 37.0515 596.794 37.2129 596.526C37.4549 596.123 38.3155 594.862 39.3105 594.996C39.8484 595.077 40.2249 595.506 40.44 596.284C41.0855 598.645 39.9829 601.677 39.9291 601.811C39.8753 602.08 39.6601 602.214 39.445 602.214Z" fill="#33C173" />
            <path d="M47.4854 603.824C47.3778 603.824 47.2971 603.797 47.1895 603.743C46.2752 603.18 45.2263 602.321 45.4415 601.57C45.6566 600.845 46.6248 600.845 46.9744 600.845C47.7543 600.845 48.077 600.604 48.1039 600.523C48.1039 600.47 47.9694 600.255 47.4047 600.067C46.1676 599.638 45.9524 599.048 46.0062 598.645C46.0869 597.974 46.813 597.518 48.1039 597.33C48.5879 597.277 48.6956 597.143 48.6956 597.143C48.6956 597.089 48.6417 596.955 48.5879 596.848L47.7274 596.418C47.4585 596.284 47.3509 595.962 47.4854 595.694C47.6198 595.425 47.9425 595.318 48.2115 595.452L49.1797 595.935C49.2334 595.962 49.2872 596.016 49.341 596.069C49.3947 596.15 49.9595 596.821 49.7175 597.518C49.5292 598.001 49.0452 598.296 48.2653 598.404C47.6198 598.484 47.2702 598.645 47.1358 598.753C47.2164 598.833 47.4047 598.94 47.7812 599.075C49.2602 599.584 49.2334 600.47 49.1797 600.738C49.0452 601.489 48.2115 601.946 47.0013 601.946C46.8399 601.946 46.7324 601.946 46.6248 601.972C46.8399 602.214 47.2971 602.589 47.7543 602.858C47.9963 603.019 48.077 603.341 47.9157 603.609C47.835 603.743 47.6736 603.824 47.4854 603.824Z" fill="#DBC8F3" />
            <path d="M57.7308 617.722C55.6869 617.669 55.5524 617.025 55.5256 616.81C55.3911 616.139 56.1172 615.71 57.2198 615.254C57.4618 615.146 57.5963 614.959 57.5695 614.771C57.5425 614.61 57.408 614.422 57.0854 614.395C55.4181 614.315 54.6381 613.993 54.5036 613.322C54.3423 612.517 55.3104 611.927 56.1979 611.471C56.4937 611.31 56.5744 611.175 56.5475 611.149C56.5475 611.095 56.4399 610.988 56.2786 610.934C56.0096 610.854 55.1759 610.666 54.8801 610.612C54.5843 610.558 54.396 610.263 54.4768 609.968C54.5305 609.673 54.8263 609.485 55.1221 609.566C55.2298 609.592 56.2517 609.807 56.6282 609.914C57.193 610.102 57.5963 610.558 57.6232 611.068C57.6501 611.39 57.5695 611.98 56.682 612.437C56.0634 612.758 55.7944 612.973 55.6601 613.107C55.8483 613.188 56.2517 613.295 57.1392 613.349C57.8922 613.376 58.5108 613.885 58.6183 614.61C58.7528 615.334 58.3493 615.978 57.6232 616.273C57.3275 616.408 57.0854 616.515 56.924 616.595C57.166 616.622 57.4618 616.649 57.7308 616.676C58.0266 616.676 58.2686 616.917 58.2686 617.213C58.2686 617.481 58.0266 617.722 57.7308 617.722Z" fill="#FEF287" />
            <path d="M50.2575 607.956C50.1232 607.956 49.9887 607.902 49.8811 607.795C49.6659 607.581 49.6659 607.259 49.8811 607.044C52.6241 604.307 58.2718 604.683 58.5138 604.71C58.8096 604.736 59.0248 604.978 58.9978 605.273C58.971 605.568 58.729 605.783 58.4331 605.756C58.3793 605.756 53.0544 605.38 50.661 607.768C50.5265 607.902 50.392 607.956 50.2575 607.956Z" fill="#96E3F9" />
            <path d="M53.7256 598.806C54.5277 598.806 55.1779 598.157 55.1779 597.357C55.1779 596.557 54.5277 595.908 53.7256 595.908C52.9235 595.908 52.2734 596.557 52.2734 597.357C52.2734 598.157 52.9235 598.806 53.7256 598.806Z" fill="#F9D271" />
            <path d="M36.8614 607.741C37.6634 607.741 38.3136 607.092 38.3136 606.292C38.3136 605.491 37.6634 604.843 36.8614 604.843C36.0594 604.843 35.4092 605.491 35.4092 606.292C35.4092 607.092 36.0594 607.741 36.8614 607.741Z" fill="#8047F1" />
            <path d="M51.9763 601.838C52.4367 601.838 52.8099 601.466 52.8099 601.007C52.8099 600.547 52.4367 600.175 51.9763 600.175C51.5158 600.175 51.1426 600.547 51.1426 601.007C51.1426 601.466 51.5158 601.838 51.9763 601.838Z" fill="#3CF216" />
            <path d="M56.4675 608.358C56.9279 608.358 57.3012 607.985 57.3012 607.526C57.3012 607.067 56.9279 606.694 56.4675 606.694C56.007 606.694 55.6338 607.067 55.6338 607.526C55.6338 607.985 56.007 608.358 56.4675 608.358Z" fill="#33C173" />
            <path d="M50.8445 615.898C51.3049 615.898 51.6781 615.526 51.6781 615.066C51.6781 614.607 51.3049 614.234 50.8445 614.234C50.3841 614.234 50.0107 614.607 50.0107 615.066C50.0107 615.526 50.3841 615.898 50.8445 615.898Z" fill="#33C173" />
            <path d="M56.573 601.409C57.1226 601.409 57.5681 600.965 57.5681 600.417C57.5681 599.868 57.1226 599.424 56.573 599.424C56.0236 599.424 55.5781 599.868 55.5781 600.417C55.5781 600.965 56.0236 601.409 56.573 601.409Z" fill="#F9D271" />
            <path d="M55.5956 603.042C55.6837 602.5 55.3152 601.99 54.7728 601.903C54.2304 601.815 53.7192 602.182 53.6312 602.724C53.5431 603.265 53.9115 603.775 54.4539 603.863C54.9964 603.95 55.5076 603.583 55.5956 603.042Z" fill="#F9D271" />
            <path d="M40.5439 610.961C41.0934 610.961 41.5389 610.517 41.5389 609.968C41.5389 609.42 41.0934 608.976 40.5439 608.976C39.9943 608.976 39.5488 609.42 39.5488 609.968C39.5488 610.517 39.9943 610.961 40.5439 610.961Z" fill="#F9D271" />
          </g>
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="16"
            letter-spacing="0em"
          ><tspan x="67" y="612.264">Confetti</tspan></text>
          <rect
            x="199"
            y="593"
            width="28"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="208.242" y="611.606">C</tspan></text>
          <g clip-path="url(#clip2_3116_4829)">
            <path d="M59.0008 632.879C59.0008 633.02 58.9162 633.132 58.8317 633.217C57.9296 634.117 57.0276 635.017 56.1255 635.888C55.9283 636.085 55.6464 636.085 55.4773 635.888C55.3081 635.72 55.3363 635.467 55.5336 635.27C56.4356 634.37 57.3377 633.47 58.2397 632.57C58.3806 632.429 58.5498 632.345 58.7752 632.429C58.9162 632.542 59.0008 632.682 59.0008 632.879Z" fill="#62ACFF" />
            <path d="M42.7633 631.163C42.9042 631.163 43.0452 631.247 43.1297 631.416C43.5525 632.401 43.9754 633.413 44.3982 634.397C44.5109 634.622 44.3982 634.875 44.1727 634.96C43.9472 635.044 43.7217 634.96 43.6089 634.735C43.1861 633.75 42.7633 632.766 42.3404 631.782C42.2277 631.472 42.425 631.163 42.7633 631.163Z" fill="#C98919" />
            <path d="M53.8112 635.86C53.5574 635.86 53.3602 635.522 53.5011 635.241C53.783 634.651 54.093 634.06 54.3749 633.469C54.4876 633.244 54.6005 632.991 54.7132 632.738C54.8541 632.485 55.0795 632.373 55.3051 632.485C55.5307 632.598 55.6152 632.851 55.4743 633.104C55.0795 633.919 54.6568 634.763 54.234 635.579C54.2058 635.747 54.0648 635.832 53.8112 635.86Z" fill="#62ACFF" />
            <path d="M42.7358 635.409C42.7076 635.606 42.6231 635.747 42.4539 635.803C42.2566 635.888 42.0875 635.831 41.9466 635.663C41.6365 635.269 41.2982 634.875 40.9881 634.481C40.7626 634.2 40.5371 633.919 40.3116 633.638C40.1143 633.385 40.1143 633.131 40.3398 632.963C40.5371 632.794 40.7908 632.85 40.9881 633.103C41.5237 633.778 42.0593 634.453 42.5949 635.1C42.6794 635.184 42.7358 635.297 42.7358 635.409Z" fill="#C98919" />
            <path d="M46.1728 633.3C46.1728 633.694 46.1728 634.116 46.1728 634.51C46.1728 634.819 46.0037 634.988 45.75 634.988C45.4963 634.988 45.3271 634.819 45.3271 634.51C45.3271 633.694 45.3271 632.878 45.3271 632.063C45.3271 631.754 45.4963 631.557 45.75 631.557C46.0037 631.557 46.201 631.754 46.201 632.063C46.1728 632.485 46.1728 632.907 46.1728 633.3Z" fill="#C98919" />
            <path d="M59.0003 636.281C59.0003 636.45 58.9158 636.562 58.7748 636.646C58.0702 637.068 57.3936 637.49 56.6888 637.884C56.4352 638.025 56.1815 637.968 56.0406 637.771C55.8997 637.575 55.9842 637.321 56.2097 637.181C56.9144 636.759 57.619 636.337 58.3238 635.915C58.6621 635.718 59.0003 635.943 59.0003 636.281Z" fill="#62ACFF" />
            <path d="M35.0117 647.334C35.0399 645.562 35.6319 644.015 36.9003 642.75C37.9433 641.709 38.9581 640.668 40.001 639.628C40.3393 639.29 40.593 639.319 40.9031 639.684C41.3259 640.219 41.2695 641.006 40.7903 641.512C40.142 642.187 39.4655 642.834 38.8171 643.481C38.5352 643.762 38.2534 644.043 37.9715 644.325C37.7178 644.578 37.6896 644.831 37.8869 645.028C38.0842 645.225 38.3097 645.196 38.5916 644.943C41.0158 642.525 43.44 640.134 45.8642 637.715C46.0333 637.547 46.2306 637.406 46.4843 637.378C46.879 637.35 47.2454 637.519 47.4427 637.884C47.6401 638.25 47.5837 638.672 47.2736 638.953C46.9353 639.29 46.5971 639.628 46.2588 639.965C45.0186 641.203 43.8065 642.412 42.5662 643.65C42.5098 643.706 42.4816 643.734 42.4252 643.79C42.2561 643.987 42.2561 644.24 42.4252 644.409C42.5944 644.578 42.8481 644.578 43.0454 644.409C43.44 644.015 43.8628 643.621 44.2575 643.228C46.0897 641.4 47.9219 639.572 49.7542 637.744C50.1206 637.378 50.5716 637.294 50.9381 637.519C51.5018 637.828 51.5864 638.559 51.1072 639.065C50.628 639.572 50.1206 640.05 49.6414 640.556C47.9219 642.272 46.2025 643.959 44.5112 645.674C44.4548 645.731 44.3984 645.787 44.342 645.843C44.2293 646.012 44.2293 646.265 44.3984 646.406C44.5393 646.546 44.793 646.574 44.9622 646.434C45.0186 646.378 45.0749 646.321 45.1313 646.265C46.9072 644.493 48.6831 642.722 50.4871 640.922C50.9945 640.415 51.8401 640.584 52.0374 641.259C52.1784 641.681 52.0374 642.018 51.7556 642.328C51.3327 642.75 50.8817 643.171 50.4589 643.621C49.1904 644.887 47.9219 646.153 46.6535 647.418C46.5689 647.503 46.4561 647.615 46.3716 647.727C46.1743 647.952 46.1743 648.206 46.3434 648.374C46.5125 648.543 46.7662 648.515 46.9635 648.318C47.8092 647.474 48.6549 646.631 49.5004 645.787C49.8387 645.449 50.177 645.112 50.4871 644.803C50.8817 644.409 51.3891 644.381 51.7837 644.718C52.1502 645.056 52.2066 645.618 51.8683 646.04C51.8119 646.124 51.7274 646.209 51.6427 646.293C49.9514 647.981 48.2602 649.64 46.5971 651.327C46.0615 651.862 45.5541 652.396 44.9058 652.818C41.0722 655.293 35.9419 653.071 35.1527 648.571C35.0681 648.093 35.0117 647.727 35.0117 647.334Z" fill="#F3BF4C" />
            <path d="M40.8193 654.618C41.665 654.618 42.4542 654.561 43.2717 654.336C44.4838 653.999 45.555 653.436 46.457 652.536C46.9362 652.058 47.3872 651.608 47.8946 651.158C48.0919 650.99 48.3456 650.905 48.5711 650.793C49.9242 650.005 51.2772 649.218 52.6584 648.43C53.0812 648.177 53.6168 648.346 53.8987 648.74C54.1523 649.133 54.0396 649.752 53.645 650.005C53.0812 650.371 52.4892 650.68 51.8973 651.018C50.5443 651.805 49.1913 652.593 47.81 653.352C46.908 653.858 46.0342 654.477 45.0194 654.786C43.6382 655.18 42.2851 655.124 40.9321 654.646C40.8757 654.674 40.8475 654.646 40.8193 654.618Z" fill="#C98919" />
            <path d="M51.584 643.566C51.8376 643.341 52.0632 643.116 52.2604 642.919C52.4578 642.722 52.6269 642.469 52.7396 642.216C52.7679 642.159 52.7961 642.075 52.8243 642.047C53.2471 641.822 53.6136 641.484 54.0928 641.4C54.4874 641.316 54.9101 641.569 55.0511 641.934C55.2202 642.328 55.0793 642.863 54.7129 643.087C54.0646 643.481 53.388 643.847 52.7396 644.241C52.6833 644.269 52.6269 644.325 52.5705 644.241C52.3451 643.875 51.9786 643.734 51.584 643.566Z" fill="#C98919" />
            <path d="M50.4619 648.629C50.4901 648.516 50.5748 648.488 50.6311 648.432C51.1949 647.869 51.7586 647.307 52.3224 646.744C52.7171 646.351 52.9425 645.872 52.9425 645.31C52.9425 645.254 52.9144 645.141 52.9989 645.113C53.3372 644.944 53.6191 644.663 54.0136 644.663C54.4084 644.663 54.6902 644.832 54.8311 645.169C55.0003 645.535 54.9157 645.929 54.662 646.21C54.4647 646.435 54.1828 646.547 53.9574 646.688C52.8298 647.335 51.7022 647.982 50.5466 648.657C50.5183 648.657 50.5183 648.685 50.4619 648.629Z" fill="#C98919" />
          </g>
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="16"
            letter-spacing="0em"
          ><tspan x="67" y="648.264">Applause</tspan></text>
          <rect
            x="199"
            y="629"
            width="28"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"

            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="207.791" y="647.606">A</tspan></text>
          <g clip-path="url(#clip3_3116_4829)">
            <path d="M47 691C51.9706 691 56 688.985 56 686.5C56 684.015 51.9706 682 47 682C42.0294 682 38 684.015 38 686.5C38 688.985 42.0294 691 47 691Z" fill="#6A37D0" />
            <path d="M47 691C51.9706 691 56 688.985 56 686.5C56 684.015 51.9706 682 47 682C42.0294 682 38 684.015 38 686.5C38 688.985 42.0294 691 47 691Z" fill="#4BADB3" />
            <path d="M56 678H38V686H56V678Z" fill="#4BADB3" />
            <path d="M47 682C51.9706 682 56 680.209 56 678C56 675.791 51.9706 674 47 674C42.0294 674 38 675.791 38 678C38 680.209 42.0294 682 47 682Z" fill="#6A37D0" />
            <path d="M47 680C51.9705 680 56 677.985 56 675.5C56 673.015 51.9705 671 47 671C42.0294 671 38 673.015 38 675.5C38 677.985 42.0294 680 47 680Z" fill="#6A37D0" />
            <path
              d="M50 683V688"
              stroke="#F3BF4C"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M55 681V686"
              stroke="#F3BF4C"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M44 683V688"
              stroke="#F3BF4C"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M39 681V686"
              stroke="#F3BF4C"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M40.1115 678.43H39.964C39.8796 678.43 39.8164 678.283 39.8164 678.136V676.664C39.8164 676.495 39.9007 676.369 39.964 676.369H40.1115C40.1959 676.369 40.2591 676.516 40.2591 676.664V678.136C40.2591 678.304 40.1959 678.43 40.1115 678.43Z" fill="#6A37D0" />
            <path d="M54.7014 678.429H54.5539C54.4695 678.429 54.4062 678.282 54.4062 678.135V676.705C54.4062 676.536 54.4906 676.41 54.5539 676.41H54.7014C54.7858 676.41 54.849 676.557 54.849 676.705V678.135C54.849 678.324 54.7858 678.429 54.7014 678.429Z" fill="#6A37D0" />
            <path d="M47 681C51.4183 681 55 678.985 55 676.5C55 674.015 51.4183 672 47 672C42.5817 672 39 674.015 39 676.5C39 678.985 42.5817 681 47 681Z" fill="white" />
            <path d="M58.9388 670.774C58.7702 670.564 58.475 670.543 58.2642 670.711L51.0332 676.474C50.5905 676.264 49.9791 676.39 49.5364 676.832C49.0094 677.357 48.925 678.157 49.3888 678.598C49.8315 679.04 50.6326 678.977 51.1597 678.451C51.497 678.115 51.6446 677.652 51.6024 677.273L58.8967 671.468C59.0864 671.279 59.1075 670.963 58.9388 670.774Z" fill="#F3BF4C" />
            <path d="M36.1057 669.175C36.2743 668.965 36.5695 668.944 36.7803 669.112L43.948 674.791C44.3907 674.581 45.0021 674.707 45.4448 675.149C45.9719 675.675 46.0562 676.474 45.5924 676.916C45.1497 677.357 44.3486 677.294 43.8215 676.768C43.4842 676.432 43.3367 675.969 43.3788 675.59L36.1689 669.869C35.9792 669.68 35.937 669.386 36.1057 669.175Z" fill="#F3BF4C" />
          </g>
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"
            font-size="16"
            letter-spacing="0em"
          ><tspan x="67" y="684.264">Drumroll</tspan></text>
          <rect
            x="199"
            y="665"
            width="28"
            height="28"
            rx="4"
            fill="#D3D7E1"
          />
          <text
            fill="#282E3E"
            xml:space="preserve"
            style="white-space: pre"
            font-size="14"
            font-weight="bold"
            letter-spacing="0em"
          ><tspan x="207.668" y="683.606">D</tspan></text>
        </g>
        <path
          v-if="showSubmissionGroup"
          class="submission-group"
          ref="submission-pointer"
          :style="submissionPointerTranslateX"
          d="M419.333 746C419.333 744.527 420.527 743.333 422 743.333C423.473 743.333 424.667 744.527 424.667 746C424.667 747.473 423.473 748.667 422 748.667C420.527 748.667 419.333 747.473 419.333 746ZM421.5 746V702H422.5V746H421.5Z"
          fill="white"
        />
        <path
          class="effect-group"
          ref="effect-pointer"
          :style="effectPointerTranslateX"
          d="M267.667 744C267.667 742.527 266.473 741.333 265 741.333C263.527 741.333 262.333 742.527 262.333 744C262.333 745.473 263.527 746.667 265 746.667C266.473 746.667 267.667 745.473 267.667 744ZM265.5 744V663H264.5V744H265.5ZM249 646.5H239V647.5H249V646.5ZM265.5 663C265.5 653.887 258.113 646.5 249 646.5V647.5C257.56 647.5 264.5 654.44 264.5 663H265.5Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_3116_4829"
          x="-20"
          y="-20"
          width="1480"
          height="850"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_3116_4829"
          x="-24"
          y="-24"
          width="1488"
          height="108"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_b_3116_4829"
          x="-5"
          y="721"
          width="405"
          height="94"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="11.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_b_3116_4829"
          x="362"
          y="721"
          width="120"
          height="94"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="11.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_3116_4829"
          x="373"
          y="734"
          width="98"
          height="70"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_b_3116_4829"
          x="964"
          y="53"
          width="280"
          height="112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_b_3116_4829"
          x="315"
          y="551"
          width="314"
          height="112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_b_3116_4829"
          x="314"
          y="629"
          width="312"
          height="112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_b_3116_4829"
          x="-7"
          y="53"
          width="276"
          height="112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_b_3116_4829"
          x="-7"
          y="551"
          width="276"
          height="184"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3116_4829" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3116_4829"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3116_4829">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(297 756)"
          />
        </clipPath>
        <clipPath id="clip1_3116_4829">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(35 595)"
          />
        </clipPath>
        <clipPath id="clip2_3116_4829">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(35 631)"
          />
        </clipPath>
        <clipPath id="clip3_3116_4829">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(35 667)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

const frameId = 'main-content-presenting'
const qrCodeId = 'show-qrcode-instruction-button'
const effectId = 'effect-toggler'
const resultId = 'result-toggler'
const submissionToggleId = 'submission-toggler'

const qrCodePointer = 'qr-code-pointer'
const effectPointer = 'effect-pointer'
const resultPointer = 'result-pointer'
const submissionPointer = 'submission-pointer'
const layerWidth = 1440

const baseTranslateX = 'transform: translateX(0px)'

export default {
  data() {
    return {
      qrPointerTranslateX: baseTranslateX,
      effectPointerTranslateX: baseTranslateX,
      resultPointerTranslateX: baseTranslateX,
      submissionPointerTranslateX: baseTranslateX,
    }
  },
  computed: {
    ...mapGetters('presentationHotKeyModule', ['showResultGroup', 'showSubmissionGroup', 'showChat']),
  },
  mounted() {
    // In the future if the layout postion changes, we can recalculate the position.
    // just call this.calculatePosition() when the layout changes.
    this.calculatePosition()
  },
  methods: {
    getFrameBoundingData() {
      const frame = document.getElementById(frameId)
      if (!frame) return 0
      return frame.getBoundingClientRect()
    },
    calculatePosition() {
      this.qrPointerTranslateX = this.calculateAlign(document.getElementById(qrCodeId), this.$refs[qrCodePointer])
      this.submissionPointerTranslateX =
        this.calculateAlign(document.getElementById(submissionToggleId), this.$refs[submissionPointer])
      this.effectPointerTranslateX =
        this.calculateAlign(document.getElementById(effectId), this.$refs[effectPointer], true)
      this.resultPointerTranslateX = this.calculateAlign(document.getElementById(resultId), this.$refs[resultPointer])
    },
    calculateAlign(targetElement, alignElement, takeRight) {
      const targetElementX = this.calculateXFromSlideWrapperFrame(targetElement, true)
      const alignElementX = this.calculateXFromSlideWrapperFrame(alignElement, false, takeRight)
      if (!targetElementX || !alignElementX) {
        return this.toTranslateX(0)
      }

      const absX = Math.abs(targetElementX - alignElementX)
      const translateX = targetElementX - alignElementX > 0
        ? absX
        : -absX
      return this.toTranslateX(translateX)
    },
    toTranslateX(val) {
      return `transform: translateX(${val}px)`
    },
    calculateXFromSlideWrapperFrame(element, useMiddlePoint, takeRight) {
      // Frame proably has a X position from the Left side of the screen.
      // We need to calculate the space of the element from the frame.

      // Therefore, I choose to calculate the middle point of the element from the screen then subtract the frame X position.
      // Formula : middlePoint - frameX
      // 1440 is the width of the CheatsheetLayer and it sclales with the screen size.
      // So base on the ratio, I will calculate the middle point of the element from the screen.
      if (!element) return null
      const elRect = element.getBoundingClientRect()

      let comparePoint = takeRight ? elRect.right : elRect.x
      if (useMiddlePoint) {
        comparePoint = (elRect.x + elRect.right) / 2
      }
      const frameBoundingData = this.getFrameBoundingData()
      return ((comparePoint - frameBoundingData.x) / frameBoundingData.width) * layerWidth
    },
  },
}
</script>
<style lang="scss" scoped>
  .cheatsheet {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 21;

    & > svg {
      width: 100%;
      height: auto;
    }

    & .back-button-pointer {
      transform: translateX(-4px);
    }
  }

</style>
